'use client';

// Delete control for a browser-login row. Port of apps/web's
// app/connections/browser-login-controls.tsx (DeleteBrowserLoginButton) — that
// file was already a 'use client' component with no server-action call of its
// own (the action lived in the <form action={deleteBrowserLoginAction}>
// wrapping it). Here the confirm-then-delete flow is inlined into a plain
// onClick handler that calls the `onDelete` callback (client.tsx wires this to
// `DELETE /api/connections/browser-logins/:id`), since there is no Next form
// action to submit to anymore.
import { useState } from 'react';
import { TrashSimple } from '@phosphor-icons/react';

export function DeleteBrowserLoginButton({
  connectionId,
  label,
  onDelete,
}: {
  connectionId: string;
  label: string;
  onDelete: (connectionId: string) => Promise<void>;
}) {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    if (!window.confirm(`Remove the browser login for ${label}? The saved logged-in state will be deleted.`)) {
      return;
    }
    setBusy(true);
    try {
      await onDelete(connectionId);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      disabled={busy}
      onClick={() => void handleClick()}
      aria-label={`Remove browser login for ${label}`}
      className="grid size-8 shrink-0 place-items-center rounded-full border border-border/70 text-muted-foreground transition-colors hover:border-red-400/40 hover:bg-red-500/10 hover:text-red-400 disabled:opacity-50"
    >
      <TrashSimple weight="duotone" className="size-4" />
    </button>
  );
}
